













import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '伝統的なてぬぐいは生地が切りっぱなし。それは「水の抜けを良くして、速乾性を高める」のが理由。でもそれではほつれが生まれます。そこで私たちは、ほつれを防げるようにロックミシンを採用し、速乾性もよりUPさせました。これはどこにも真似のできない、どこにも負けない独自の技術です。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
